import GiftOrderApi from '@apis/gift/GiftOrderApi';
import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import styled from '@emotion/styled';
import useToast from '@hooks/ui/useToast';
import ModalContainer from '@modals/ModalContainer';
import { ErrorResponse } from '@models/error';
import { CancelGiftOrderRequest } from '@models/gift';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

declare module '@stackflow/config' {
    interface Register {
        GiftCancelModal: CancelGiftOrderRequest;
    }
}

const GiftCancelModal: ActivityComponentType<'GiftCancelModal'> = ({ params }) => {
    const { pop, push } = useFlow();
    const toast = useToast();
    const { t } = useTranslation('gift');
    const handleCancel = () => {
        GiftOrderApi.cancelOrder(params)
            .then(() => {
                pop(2);
                push('GiftCanceledModal', {});
            }).catch((e: AxiosError<ErrorResponse>) => {
                toast.error(e.message);
            });
    };
    return (
        <Modal>
            <ModalContainer>
                <Column spacing={32} fullWidth>
                    <Column spacing={8}>
                        <Title size='3xl' fontWeight='bold'>
                            {t('giftCancelModal.title')}
                        </Title>
                        <Text size='xl' align='center'>
                            {t('giftCancelModal.description')}
                        </Text>
                    </Column>
                    <Row fullWidth spacing={10}>
                        <Button variant='secondary' fullWidth
                            noPadding
                            onClick={pop} >
                            {t('giftCancelModal.cancel')}
                        </Button>
                        <Button fullWidth
                            noPadding
                            onClick={handleCancel}>
                            {t('giftCancelModal.confirm')}
                        </Button>
                    </Row>
                </Column>
            </ModalContainer>
        </Modal>
    );
};

const Title = styled(Text)`
    font-size: 24px;
    line-height: 36px;
`;

export default GiftCancelModal;
